import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function Admin({
    children
}) {

    const { user } = useSelector(state => state.global)
    const nav = useNavigate()

    return user?.user_roles?.includes('admin') ? children : nav('/individualAcc', { replace: true });
}
